import React, { useState } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import ManageAppointments from './ManageAppointments';
import ManageTimings from './ManageTimings';
import ManageServices from './ManageServices';
import { useNavigate } from 'react-router-dom';

const AdminDashboard: React.FC = () => {
    const [activeTab, setActiveTab] = useState('appointments');
    const navigate = useNavigate();

    const handleLogout = async () => {
        const auth = getAuth();
        try {
            await signOut(auth);
            navigate('/login');
        } catch (error) {
            console.error('Failed to log out:', error);
        }
    };

    const tabClasses = (tab: string) =>
        `p-2 rounded-md mb-2 md:mb-0 md:mr-2 ${
            activeTab === tab ? 'bg-primary text-white' : 'bg-gray-200 text-gray-700'
        }`;

    return (
        <div className="p-4 md:p-6 bg-white rounded-lg shadow-lg">
            <div className="flex flex-col md:flex-row justify-between items-center mb-6">
                <h1 className="text-2xl font-bold mb-4 md:mb-0">Admin Dashboard</h1>
                <button
                    onClick={handleLogout}
                    className="bg-gray-300 text-gray-800 p-2 rounded-md hover:bg-gray-400 transition duration-300"
                >
                    Logout
                </button>
            </div>
            <div className="flex flex-col md:flex-row mb-6">
                <button
                    onClick={() => setActiveTab('appointments')}
                    className={tabClasses('appointments')}
                >
                    Manage Appointments
                </button>
                {/* <button
                    onClick={() => setActiveTab('timings')}
                    className={tabClasses('timings')}
                >
                    Manage Timings
                </button> */}
                <button
                    onClick={() => setActiveTab('services')}
                    className={tabClasses('services')}
                >
                    Manage Services
                </button>
            </div>
            <div>
                {activeTab === 'appointments' && <ManageAppointments />}
                {activeTab === 'timings' && <ManageTimings />}
                {activeTab === 'services' && <ManageServices />}
            </div>
        </div>
    );
};

export default AdminDashboard;